import { useMutation } from '@tanstack/react-query'

import { FailureEnvelop } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'

interface Params {
    id: string
}

export default function usePostNotifyMe({ id }: Params) {
    return useMutation<unknown, FailureEnvelop['errors']>({
        mutationFn: async () =>
            fetchRequest({
                method: 'POST',
                serviceName: 'ntl',
                endpoint: `/products/id/${id}/notify-user`,
            }),
    })
}
